module.exports = __webpack_public_path__ + "img/Icon ionic-ios-arrow-up-gray-small.5b70f5c9.svg";